import Vue from 'vue'

const LATENCY = 50
let timerProduct = null
let timerFilter = null
let url = null

export function setUrl (baseUrl, lang) {
  url = baseUrl + '/?ACT=86&lang=' + lang
}

export function fetchProducts (filterList, callback) {
  if (timerProduct) {
    window.clearTimeout(timerProduct)
  }

  timerProduct = setTimeout(_ => {
    Vue.http.get(url, {params: filterList}, {emulateJSON: true}).then(response => {
      callback(response.body.results)
    }, error => {
      console.warn(error)
    })
  }, LATENCY)
}

export function fetchFilters (genderId, callback) {
  if (timerFilter) {
    window.clearTimeout(timerFilter)
  }

  timerFilter = setTimeout(_ => {
    Vue.http.get(url, {params: {method: 'filters', g: genderId}}, {emulateJSON: true}).then(response => {
      callback(response.body.results)
    }, error => {
      console.warn(error)
    })
  }, LATENCY)
}



// WEBPACK FOOTER //
// ./src/api/index.js